import React from 'react'
import {
  PersonOutline,
  Person,
  Timelapse,
  AccessTime,
  CheckCircle,
  Error,
  PlayCircleFilled,
  PauseCircleFilled,
  LocalShipping,
  Help,
  DeleteForever,
  Assignment,
} from '@mui/icons-material_modern'
import { DISPATCH_TICKET_STATUSES, ASSET_STATUSES, DISPATCH_TICKET_TYPES } from 'utils/constants'

export const DISPATCH_STATUS_ICONS_DICT = {
  [DISPATCH_TICKET_STATUSES.REQUESTED.id]: {
    previewModal: <Assignment sx={{ color: 'text.hint' }} />,
    loadBoard: <Assignment sx={{ fontSize: '1rem', color: 'text.hint' }} />,
  },
  [DISPATCH_TICKET_STATUSES.IN_PROGRESS.id]: {
    previewModal: <Timelapse sx={{ color: 'rgba(33, 150, 243, 1)' }} />,
    loadBoard: <Timelapse sx={{ fontSize: '1rem', color: 'rgba(33, 150, 243, 1)' }} />,
  },
  [DISPATCH_TICKET_STATUSES.COMPLETED.id]: {
    previewModal: <CheckCircle sx={{ color: 'rgba(76, 175, 80, 1)' }} />,
    loadBoard: <CheckCircle sx={{ fontSize: '1rem', color: 'rgba(76, 175, 80, 1)' }} />,
  },
  [DISPATCH_TICKET_STATUSES.FAILED.id]: {
    previewModal: <Error sx={{ color: 'rgba(244, 67, 54, 1)' }} />,
    loadBoard: <Error sx={{ fontSize: '1rem', color: 'rgba(244, 67, 54, 1)' }} />,
  },
  [DISPATCH_TICKET_STATUSES.ASSIGNED.id]: {
    previewModal: <Person sx={{ color: 'text.hint' }} />,
    loadBoard: <AccessTime sx={{ fontSize: '1rem', color: 'text.hint' }} />,
  },
  [DISPATCH_TICKET_STATUSES.UNASSIGNED.id]: {
    previewModal: <PersonOutline sx={{ color: 'text.hint' }} />,
    loadBoard: <AccessTime sx={{ fontSize: '1rem', color: 'text.hint' }} />,
  },
  [DISPATCH_TICKET_STATUSES.VOID.id]: {
    previewModal: <DeleteForever sx={{ color: 'rgba(244, 67, 54, 1)' }} />,
    loadBoard: <DeleteForever sx={{ fontSize: '1rem', color: 'rgba(244, 67, 54, 1)' }} />,
  },
}

export const ASSET_STATUS_ICONS_DICT = {
  [ASSET_STATUSES.DEPLOYED.id]: <LocalShipping sx={{ color: 'rgba(76, 175, 80, 1)' }} />,
  [ASSET_STATUSES.IN_PROGRESS.id]: <PlayCircleFilled sx={{ color: 'rgba(33, 150, 243, 1)' }} />,
  [ASSET_STATUSES.INVENTORY.id]: <PauseCircleFilled sx={{ color: 'rgba(255, 152, 0, 1)' }} />,
  [ASSET_STATUSES.FAILED.id]: <Error sx={{ color: 'rgba(244, 67, 54, 1)' }} />,
  UNKNOWN: <Help sx={{ color: 'rgba(244, 67, 54, 1)' }} />, // catch-all in case asset status is missing
}

export const DRAG_DROP_BACKGROUND_COLOR = {
  [DISPATCH_TICKET_STATUSES.REQUESTED.id]: 'rgba(0, 0, 0, 0.08)',
  [DISPATCH_TICKET_STATUSES.IN_PROGRESS.id]: 'rgba(33, 150, 243, 0.1)',
  [DISPATCH_TICKET_STATUSES.COMPLETED.id]: 'rgba(76, 175, 80, 0.1)',
  [DISPATCH_TICKET_STATUSES.FAILED.id]: 'rgba(244, 67, 54, 0.1)',
  [DISPATCH_TICKET_STATUSES.ASSIGNED.id]: 'rgba(0, 0, 0, 0.08)',
  [DISPATCH_TICKET_STATUSES.UNASSIGNED.id]: 'rgba(0, 0, 0, 0.08)',
  [DISPATCH_TICKET_STATUSES.VOID.id]: 'rgba(244, 67, 54, 0.1)',
}

export const SUBMIT_FORM_TYPES = {
  DEFAULT: 'DEFAULT',
  BLADE: 'BLADE',
  ATTACHMENTS: 'ATTACHMENTS',
}

export const defaultTicketPreviewModalValues = {
  driver: null,
  type: '',
  customerName: '',
  customerLocation: '',
  notes: '',
  scheduleDate: new Date(),
  scheduleDateString: '',
  scheduleTime: new Date(),
  scheduleTimeString: '',
  startDate: new Date(),
  startDateString: '',
  endDate: new Date(),
  endDateString: '',
  pickup: '',
  dropoff: '',
}

export const inputPropsStandard = {
  InputProps: {
    readOnly: true,
    disableUnderline: true,
  },
  sx: {
    input: { padding: '4px' },
    label: { padding: '4px' },
    textarea: {
      padding: '4px',
    },
  },
  variant: 'standard',
  InputLabelProps: { shrink: true },
}

export const inputPropsFilled = {
  InputProps: {
    disableUnderline: true,
    sx: { borderRadius: '8px' },
  },
  variant: 'filled',
  size: 'small',
}

// Each array represents the types that the key type can be swapped to without losing asset data
export const VALID_TRIP_TYPE_SWAPS = {
  [DISPATCH_TICKET_TYPES.PICK_UP.id]: [DISPATCH_TICKET_TYPES.EXCHANGE.id, DISPATCH_TICKET_TYPES.PICK_AND_RETURN.id],
  [DISPATCH_TICKET_TYPES.DROP_OFF.id]: [DISPATCH_TICKET_TYPES.EXCHANGE.id, DISPATCH_TICKET_TYPES.LIVE_LOAD.id],
  [DISPATCH_TICKET_TYPES.EXCHANGE.id]: [
    DISPATCH_TICKET_TYPES.PICK_UP.id,
    DISPATCH_TICKET_TYPES.DROP_OFF.id,
    DISPATCH_TICKET_TYPES.LIVE_LOAD.id,
  ],
  [DISPATCH_TICKET_TYPES.PICK_AND_RETURN.id]: [DISPATCH_TICKET_TYPES.PICK_UP.id],
  [DISPATCH_TICKET_TYPES.DELIVERY.id]: [],
  [DISPATCH_TICKET_TYPES.LIVE_LOAD.id]: [DISPATCH_TICKET_TYPES.DROP_OFF.id, DISPATCH_TICKET_TYPES.EXCHANGE.id],
}
